<div class="skeletor-conf">
  <div class="skeletor-conf-header">
    <p-skeleton [width]="'18rem'" [height]="'1.2rem'" />
    <p-skeleton [width]="'12rem'" [height]="'1rem'" />
  </div>

  <div class="skeletor-conf-panel">
    <p-skeleton [width]="'10rem'" [height]="'1rem'" />
    <div class="skeletor-conf-row">
      <p-skeleton [width]="'16rem'" [height]="'1rem'" />
      <p-skeleton [width]="'3.5rem'" [height]="'2rem'" />
    </div>
    <p-skeleton [width]="'100%'" [height]="'2rem'" />
  </div>

  <div class="skeletor-conf-panel">
    <p-skeleton [width]="'12rem'" [height]="'1rem'" />
    <div class="skeletor-conf-two-col">
      <div class="skeletor-conf-col">
        <p-skeleton [width]="'8rem'" [height]="'1rem'" />
        <p-skeleton [width]="'100%'" [height]="'2rem'" />
      </div>
      <div class="skeletor-conf-col">
        <p-skeleton [width]="'8rem'" [height]="'1rem'" />
        <p-skeleton [width]="'100%'" [height]="'2rem'" />
      </div>
    </div>
  </div>

  <div class="skeletor-conf-panel">
    <p-skeleton [width]="'10rem'" [height]="'1rem'" />
    <div class="skeletor-conf-two-col">
      <div class="skeletor-conf-col">
        <p-skeleton [width]="'8rem'" [height]="'1rem'" />
        <p-skeleton [width]="'100%'" [height]="'2rem'" />
      </div>
      <div class="skeletor-conf-col" style="max-width:8rem">
        <p-skeleton [width]="'4rem'" [height]="'1rem'" />
        <p-skeleton shape="circle" [width]="'2rem'" [height]="'2rem'" />
      </div>
      <div class="skeletor-conf-col" style="max-width:10rem; align-items: flex-end;">
        <p-skeleton [width]="'8rem'" [height]="'2rem'" />
      </div>
    </div>
    <p-skeleton [width]="'100%'" [height]="'2.5rem'" />
    <div class="skeletor-conf-list">
      <div class="skeletor-conf-list-item" *ngFor="let i of rows">
        <div style="display:flex; align-items:center; gap:0.5rem;">
          <p-skeleton shape="circle" [width]="'1.5rem'" [height]="'1.5rem'" />
          <div>
            <p-skeleton [width]="'10rem'" [height]="'1rem'" />
            <p-skeleton [width]="'8rem'" [height]="'0.8rem'" />
          </div>
        </div>
        <div style="display:flex; align-items:center; gap:0.5rem;">
          <p-skeleton [width]="'3rem'" [height]="'1rem'" />
          <p-skeleton shape="circle" [width]="'2rem'" [height]="'2rem'" />
        </div>
      </div>
    </div>
  </div>

  <div class="skeletor-conf-panel">
    <p-skeleton [width]="'12rem'" [height]="'1rem'" />
    <div class="skeletor-conf-two-col">
      <div class="skeletor-conf-col">
        <p-skeleton [width]="'10rem'" [height]="'1rem'" />
        <p-skeleton [width]="'100%'" [height]="'2rem'" />
      </div>
      <div class="skeletor-conf-col">
        <p-skeleton [width]="'10rem'" [height]="'1rem'" />
        <p-skeleton [width]="'100%'" [height]="'2rem'" />
      </div>
      <div class="skeletor-conf-col" style="align-items: flex-end;">
        <p-skeleton [width]="'8rem'" [height]="'2rem'" />
      </div>
    </div>
    <p-skeleton [width]="'10rem'" [height]="'1rem'" />
    <div class="skeletor-conf-list">
      <div class="skeletor-conf-list-item" *ngFor="let i of rows">
        <p-skeleton [width]="'10rem'" [height]="'1rem'" />
        <div style="display:flex; align-items:center; gap:0.5rem;">
          <p-skeleton [width]="'3rem'" [height]="'1rem'" />
          <p-skeleton shape="circle" [width]="'2rem'" [height]="'2rem'" />
        </div>
      </div>
    </div>
  </div>
</div>

